/**
 * Affaire Detail Constants
 */

export const STAGES: Record<string, string> = {
  'Bureau à encoder': 'Bureau à encoder',
  'Bureau à planifier': 'Bureau à planifier',
  'RV en attente 1° contact': 'RV en attente',
  'RV en attente 2° contact': 'RV en attente (2°)',
  'RV en attente 3° contact': 'RV en attente (3°)',
  'Expert à visiter': 'Expert à visiter',
  'Expert à achever': 'Expert à achever',
  'Bureau à valoriser': 'Bureau à valoriser',
  'Bureau à achever': 'Bureau à achever',
  'Attente doc/infos': 'Attente doc/infos',
  'Attente paiement client': 'Attente paiement',
  'Attente paiement courtier': 'Attente paiement',
  'Attente confirmation client': 'Attente confirmation',
  'Attente confirmation courtier': 'Attente confirmation',
  'A transmettre': 'À transmettre',
  'à transmettre': 'À transmettre',
  'Attente de facturation mensuelle': 'Att. facturation',
  'ARCHIVES': 'Archivé',
  'SANS SUITE': 'Sans suite',
};

export const STAGE_COLORS: Record<string, { bg: string; text: string }> = {
  'Bureau à encoder': { bg: 'bg-blue-100', text: 'text-blue-700' },
  'Bureau à planifier': { bg: 'bg-blue-100', text: 'text-blue-700' },
  'RV en attente': { bg: 'bg-yellow-100', text: 'text-yellow-700' },
  'Expert à visiter': { bg: 'bg-purple-100', text: 'text-purple-700' },
  'Expert à achever': { bg: 'bg-purple-100', text: 'text-purple-700' },
  'Bureau à valoriser': { bg: 'bg-orange-100', text: 'text-orange-700' },
  'Bureau à achever': { bg: 'bg-orange-100', text: 'text-orange-700' },
  'Attente doc/infos': { bg: 'bg-gray-100', text: 'text-gray-700' },
  'Attente paiement': { bg: 'bg-red-100', text: 'text-red-700' },
  'Attente confirmation': { bg: 'bg-amber-100', text: 'text-amber-700' },
  'À transmettre': { bg: 'bg-green-100', text: 'text-green-700' },
  'Archivé': { bg: 'bg-gray-200', text: 'text-gray-500' },
};

export const TAB_CONFIGS = [
  { key: 'resume' as const, label: 'Résumé', icon: 'HomeIcon' },
  { key: 'activite' as const, label: 'Activité', icon: 'ClockIcon' },
  { key: 'communications' as const, label: 'Communications', icon: 'ChatBubbleLeftRightIcon' },
  { key: 'documents' as const, label: 'Documents', icon: 'DocumentTextIcon' },
  { key: 'facturation' as const, label: 'Facturation', icon: 'BanknotesIcon' },
  { key: 'fiche-bien' as const, label: 'Expertise', icon: 'ClipboardDocumentCheckIcon' },
];
